@import '../../../../style/src/typography/mixins';

:host {
	@include zds-typography('body');
}

::slotted(.zds-breadcrumbs__separator) {
	flex-shrink: 0;
	margin: 0 var(--zds-space-2);
}

::slotted(.zds-breadcrumbs__crumb) {
	align-items: center;
	display: flex;
	flex-shrink: 0;
	white-space: nowrap;
}

::slotted(.zds-breadcrumbs__crumb:last-of-type) {
	flex-shrink: 1;
}

::slotted(.zds-breadcrumbs__crumb--invisible) {
	display: none;
}

.zds-breadcrumbs {
	align-items: center;
	display: flex;
	flex-wrap: wrap;
}
